/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoYoutubeIcon20Solid = forwardRef('LogoYoutubeIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.726 5.17C2 6.055 2 7.37 2 10s0 3.945.726 4.83c.133.162.282.31.444.444C4.055 16 5.37 16 8 16h4c2.63 0 3.945 0 4.83-.726.162-.133.31-.282.444-.444C18 13.945 18 12.63 18 10s0-3.945-.726-4.83a3.197 3.197 0 0 0-.444-.444C15.945 4 14.63 4 12 4H8c-2.63 0-3.945 0-4.83.726a3.2 3.2 0 0 0-.444.444ZM13 10l-5 3V7l5 3Z" })));
});
